import { Box, FormLabel, useTheme } from "@mui/material";
import React from "react";
import { useCommonStyles } from "../../utils";

const CommonLabel = ({ title, valid, subTitle, fontSize, fontWeight, fontFamily, color, marginBottom }) => {
  const { classes } = useCommonStyles();
  const theme = useTheme();

  return (
    <>
      <Box display="flex">
        <FormLabel
          className={classes.label}
          sx={{
            fontWeight: fontWeight ? fontWeight : "500",
            fontSize: fontSize ? fontSize : "14px",
            fontFamily: fontFamily ? fontFamily : "Satoshi-Medium",
            color: color || "#2E2E30",
            marginBottom: marginBottom || "8px",
            textTransform: "capitalize",
          }}
        >
          {title}{valid && <span style={{ color: theme.palette.error.main }}> *</span>}
        </FormLabel>
        <FormLabel className={classes.formLabelSubTitle}>{subTitle}</FormLabel>
      </Box>
    </>
  );
};

export default CommonLabel;
